import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { App } from './App';
import { MaybeAgentSessionProvider } from './components/agent/AgentSessionProvider';
import { bootTheme } from './lib/theme';
import './styles/index.css';

// HashRouter (not BrowserRouter) so client routing lives entirely in the URL
// fragment. penrose-web is bundled into the Penrose IDE and served from the
// Theia backend under the `/penrose-web/` subpath; BrowserRouter would treat
// `/penrose-web/index.html` as its base and push paths like `/dashboard` that
// escape the served subtree (and 404 on refresh). Hash routing is base-path
// agnostic, so it works identically standalone and inside the IDE panel.

// Apply the stored theme to <html data-theme="..."> before React renders so
// every page picks up the preference on first paint, not just landing.
bootTheme();

// The agent-session provider is mounted INSIDE <HashRouter> (so a future
// descendant can use router hooks) but ABOVE <App /> (so the one shared agent
// session outlives every route). It self-gates on isIDE(): the plain web build
// mounts a transparent pass-through and opens no WebSocket.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <MaybeAgentSessionProvider>
        <App />
      </MaybeAgentSessionProvider>
    </HashRouter>
  </React.StrictMode>
);
